import React from 'react';
import { Link } from 'react-router-dom';
import './index.scss';

export const NoConfig = () => {
  return (
    <div className="dialpad-no-config">
      <div className="no-config-header">
        <img
          className="no-config-header-icon"
          alt="Icon call center"
          src="https://db1.beex.vn/icons/ic_call_center.svg"
        />
        <p className="title" style={{ fontSize: 18, fontWeight: 'bold' }}>
          Call Center Service
        </p>
      </div>

      <div className="no-config-content">
        <p className="description">
          Go to marketplace and search <b>Call center</b> to setting and
          activating this service.
        </p>
        <Link to="/service">
          <span style={{ color: '#0E9347' }}>Go to marketplace</span>
        </Link>
      </div>
    </div>
  );
};

export default NoConfig;
